import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { VueCookieNext } from 'vue-cookie-next'
import lazyPlugin from 'vue3-lazy'
import installHead from './plugins/vue-meta';

const loadimage = require('./assets/img/trends.png')
const errorimage = require('./assets/img/trends.png')

const app = createApp(App);

app.use(router)
router.app = app
app.use(Toast)
app.use(VueCookieNext);
app.use(lazyPlugin, {
    preLoad: 1.3,
    loading: loadimage,
    error: errorimage,
    attempt: 1
})
app.use(installHead);
app.mount('#app')
